import type { FunctionComponent } from 'react'
import React, { useContext, useRef, useState } from 'react'

import { FormEntryPage } from '../../../../shared/pages/FormEntryPage'
import { ToolContext } from '../../../../shared/state/appContext'
import type { FormEntryInputRef, SingleInputState } from '../../../../shared/types/toolTypes'
import { cleanText } from '../../../../shared/utils/cleanText'
import { formatToolName } from '../../../../shared/utils/formatToolName'
import { isNotEmpty } from '../../../../shared/utils/isNotEmpty'
import { generalDataLayer } from '../../../../shared/utils/tracking'
import { DateOpenedAccountFlow, NameOfAccountFlow } from '../../pageFlowData'
import { nameOfAccountData } from './data'

export const NameOfAccount: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    initial: { entryToolName },
    account: { nameOfAccount },
  } = state

  const [inputData, setInputData] = useState<SingleInputState>({
    renderError: false,
    value: '',
  })
  const nameOfAccountInput = useRef<FormEntryInputRef>(null)

  const getValue = () => {
    return cleanText(nameOfAccountInput?.current?.formEntryInput?.value || '')
  }

  const handleTracking = (value: string) => {
    const trackingAnswer = `question | ${NameOfAccountFlow.VIEW_NAME} | ${value}`
    generalDataLayer(formatToolName(entryToolName), trackingAnswer, false)
  }

  const handleDispatch = (value: string) => {
    dispatch({ type: 'UPDATE_NAME_OF_ACCOUNT', data: value })
    dispatch({ type: 'UPDATE_STEP', data: DateOpenedAccountFlow.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: DateOpenedAccountFlow.PROGRESS_VALUE })
  }

  const handleSubmit = () => {
    const value = getValue()
    const nameOfAccountHasError = !isNotEmpty(value)

    setInputData({
      renderError: nameOfAccountHasError,
      value: value,
    })

    if (!nameOfAccountHasError) {
      handleTracking(value)
      handleDispatch(value)
    }
  }

  const { renderError, value: errorValue } = inputData
  const { imgObj, placeHolder, title } = nameOfAccountData

  return (
    <FormEntryPage
      buttonText="Next"
      defaultValue={nameOfAccount}
      fieldData={{
        renderError: renderError,
        value: errorValue,
      }}
      handleSubmit={handleSubmit}
      id="name-of-account"
      imgObj={imgObj}
      isFocused
      placeholderText={placeHolder}
      ref={nameOfAccountInput}
      testId="name-of-account"
      title={title}
    />
  )
}
